'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/table/style/css');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _css2 = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _css3 = require('antd/lib/message/style/css');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _constants = require('../constants');

var _pickup_station_form = require('./pickup_station_form');

var _pickup_station_form2 = _interopRequireDefault(_pickup_station_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PickupStationList = _react2.default.createClass({
    displayName: 'PickupStationList',

    propTypes: {
        pickupStations: _react.PropTypes.object.isRequired
    },
    render: function render() {
        var columns = [{
            title: '自提点名称',
            key: 'name',
            dataIndex: 'name'
        }, {
            title: '地址',
            key: 'address',
            render: function render(text, record) {
                return _react2.default.createElement(
                    'span',
                    null,
                    record.address.province,
                    record.address.city,
                    record.address.district,
                    record.address.street
                );
            }
        }, {
            title: '联系人',
            key: 'contact',
            dataIndex: 'contact'
        }, {
            title: '联系电话',
            key: 'mobile',
            dataIndex: 'mobile'
        }, {
            title: '操作',
            key: 'action',
            render: function render(text, record) {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_pickup_station_form2.default, { pickupStation: record, title: '\u7F16\u8F91\u81EA\u63D0\u70B9', btnText: '\u7F16\u8F91' }),
                    _react2.default.createElement(
                        _button2.default,
                        { onClick: function onClick() {
                                _axios2.default.delete(record.id).then(function () {
                                    return _message2.default.info('操作成功');
                                }).catch(function (error) {
                                    return _message2.default.error('\u64CD\u4F5C\u5931\u8D25\uFF1A' + error.data);
                                });
                            } },
                        '\u5220\u9664'
                    )
                );
            }
        }];

        var pickupStations = this.props.pickupStations;
        var items = pickupStations.items,
            error = pickupStations.error,
            isFetching = pickupStations.isFetching;

        var pagination = Object.assign(_constants.PaginationConfig, {
            total: this.props.pickupStations.items.length,
            onChange: function onChange(current, pageSize) {
                // pageSize是undefined，有待研究

            },
            onShowSizeChange: function onShowSizeChange(current, pageSize) {

            }
        });
        var tableConfig = {
            columns: columns,
            locale: { emptyText: error && !error.ok ? '\u7F51\u7EDC\u9519\u8BEF\uFF1A' + error.statusText : '暂无数据' },
            dataSource: items,
            loading: isFetching,
            pagination: pagination,
            rowKey: function rowKey(record) {
                return record.id;
            }
        };

        return _react2.default.createElement(_table2.default, tableConfig);
    }
});

exports.default = PickupStationList;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pickup_station_list.js
// module id = 1560
// module chunks = 0